import { useEffect, useState } from "react";
import { NAV_LINKS, SITE } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        open
          ? "bg-white border-b border-black/10"
          : scrolled
            ? "backdrop-blur-xl bg-white/75 border-b border-black/10"
            : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("top")}
          className="font-serif text-xl md:text-2xl tracking-tight leading-none"
        >
          <span className="italic font-light">Isabella</span>{" "}
          <span className="font-normal">Rubino</span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-[11px] uppercase tracking-[0.22em] font-medium link-underline"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-email"
            href={`mailto:${SITE.email}`}
            className="text-[11px] uppercase tracking-[0.22em] font-medium link-underline"
          >
            Email
          </a>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[11px] uppercase tracking-[0.22em] font-medium"
          aria-label="Toggle menu"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-black/10 bg-white"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => {
                  setOpen(false);
                  scrollToId(l.id);
                }}
                className="text-left font-serif text-3xl tracking-tight"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="nav-mobile-email"
              href={`mailto:${SITE.email}`}
              className="text-left font-serif text-3xl tracking-tight italic"
            >
              Email
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
